import { FC, PropsWithChildren } from 'react';
import { useLocalStorageState } from '@srm/ui/hooks/useLocalStorageState';
import { TableCursorScrollContext } from '@srm/ui/context/TableCursorScrollContext';
import { tableCursorScrollStorageKey } from '@utils/tableCursorScroll';

interface ITableCursorScrollProviderProps extends PropsWithChildren {
    username?: string;
}

const TableCursorScrollProvider: FC<ITableCursorScrollProviderProps> = ({ username, children }) => {
    const [enabled] = useLocalStorageState<boolean>(tableCursorScrollStorageKey(username ?? ''), false);

    return <TableCursorScrollContext value={!!username && enabled}>{children}</TableCursorScrollContext>;
};

export default TableCursorScrollProvider;
